import { Component, EventEmitter, Output, Input } from '@angular/core';
import { ConfirmOutput } from '../../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../../shared/enums/CRUDActions';
import { CommonFunctions } from '../../../shared/static/common-functions';
import { GlobalsService } from '../../../shared/services/globals.service';

import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { GItem } from '../../../shared/models/GItem';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { EmployeeService } from '../../../shared/services/employee.service';
import { DepartmentBus } from '../../../shared/models/DepartmentBus';
import * as _ from 'lodash';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseAppMComponent } from '../../../shared/base-components/base-app-m.component';
import { DQOIReferenceDataQuery } from '../../../dqoi/state/dqoi-reference-data.query';
import { JobRolesBus } from '../../../shared/models/JobRolesBus';
import { CostCenterBus } from '../../../shared/models/CostCenterBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'cost-center-dialog',
    templateUrl: './cost-center-dialog.component.html',
    styleUrls: ['./cost-center-dialog.component.scss'],
    standalone: false
})
export class CostCenterDialogComponent extends BaseAppMComponent<JobRolesBus, EmployeeService, null, null> {

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, public svc_data: EmployeeService, qry_rd: DQOIReferenceDataQuery, ) {
        super(globals, featureFlagService, qry_rd);

    }
    public editForm: UntypedFormGroup
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    saving: boolean = false;
    active: boolean = false;
    data: any;
    gridData: DepartmentBus[];
    action1: CRUDActions;
    techId: string;
    assignmentDateTime: Date;
    code: string;
    @Input() title: string;
    @Input() message: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    @Input() sublings: GItem[] =[];
    statusList: GItem[] = []
    incomeStatementCats = [{ value: "OVH" }, { value: "COS" }]
    hasIdValue: boolean = false;
    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action1 = CRUDActions.None;

    }
    ok() {
        this.save();
    }

    save() {
        let user = this.globals.user;

        let busObj: CostCenterBus = new CostCenterBus();
        busObj.costCenterName = this.editForm.controls["costCenterName"].value;
        busObj.lineOfBusiness = this.editForm.controls["lineOfBusiness"].value;
        busObj.incomeStatementCat = this.editForm.controls["incomeStatementCat"].value;
        busObj.costCenterId = this.editForm.controls["costCenterId"].value;
        //if (!busObj.costCenterId) { busObj.jobRoleId = CommonValues.Guid_Empty }
        busObj.insertDt = new Date(Date.now());
        busObj.updateDt = new Date(Date.now());
        busObj.insertUserId = user.userid;
        busObj.updateUserId = user.userid;
        this.svc_data.saveCostCenter(busObj).subscribe(data => {
            let result: ConfirmOutput = {
                action: this.action1, dialogResult: CPDialogResult.ok, data: {refresh:true}, code: this.code
            }
            this.confirmation.emit(result);
            this.hide();
        },
            err => { this.CallFailed(err) }
        );

    }

    CallFailed(err) {

        this.saveError(err)

    }
    cancel() {
        let result: ConfirmOutput = { action: this.action1, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action1, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(id: any) {
        this.createForm();
        this.active = true;
        this.svc_data.getCostCenters().subscribe(data => {

            let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: CostCenterBus = new CostCenterBus(data[i]);
                        newObj.display =  newObj.costCenterId.toString() + " - " + newObj.costCenterName;
                        arr.push(newObj);
                }
                    this.gridData = arr;
            }

        });

    }
    public selectionChange(value: any): void {
        if (value) {
            this.hasIdValue = true;
            this.editForm.patchValue({
                costCenterName: value.costCenterName,
                lineOfBusiness: value.lineOfBusiness,
                incomeStatementCat: value.incomeStatementCat,
                costCenterId: value.costCenterId,
              });

        }
        else {
            this.hasIdValue = false;

            this.editForm.patchValue({
                costCenterName: "",
                lineOfBusiness: "",
                incomeStatementCat: "COS",
                costCenterId: null,            });
        }

    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'costCenterId': new UntypedFormControl('', Validators.required),
            'costCenterName': new UntypedFormControl('', Validators.required),
            'lineOfBusiness': new UntypedFormControl(''),
            'incomeStatementCat': new UntypedFormControl(''),
           'costCenterselector': new UntypedFormControl(''),
            });}
}

